<template>
  <IndividualCarFilter @export="exportReport" />
</template>
<script>
import reportsApi from '../../../../services/reports.api';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';
import IndividualCarFilter from './individual-car-filter.vue';

export default {
  name: 'IndividualCar',
  components: {
    IndividualCarFilter,
  },
  methods: {
    async exportReport(filters) {
      try {
        this.$vs.loading();
        const buffer = await reportsApi.exportIndividualCarReport(filters);

        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );

        const fileName = `Relatório Auto Individual - ${now}.xlsx`;

        await functions.downloadFromBuffer(window, buffer, fileName);
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Falha ao gerar o relatório do Auto Individual',
        );
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
